/**
 * Plan module gating — deny-by-default when module list is loaded.
 * Legacy HQ admins without a stored module list keep access (not franchise users).
 */

export function readAccessModuleIds(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (raw === null) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map((m) => Number(m)).filter((n) => !Number.isNaN(n));
  } catch {
    return [];
  }
}

export function createModulePermissionMethods(storageKey, service) {
  return {
    getAllowedModules() {
      const ids = readAccessModuleIds(storageKey);
      return ids == null ? [] : ids;
    },

    has(moduleId) {
      if (service.isSuperAdmin()) return true;
      const ids = readAccessModuleIds(storageKey);
      if (ids == null) {
        return service.isAdmin() && !service.isFranchise();
      }
      const mid = Number(moduleId);
      return ids.includes(mid);
    },

    hasAny(...args) {
      const flat = args.flat();
      if (!flat.length) return false;
      return flat.some((id) => this.has(id));
    },

    hasAll(...args) {
      const flat = args.flat();
      if (!flat.length) return false;
      return flat.every((id) => this.has(id));
    },
  };
}
